'use strict';
module.exports = function() {
  $('#subsUI, .app-third-party-assets').contents().filter(function() {
    return this.nodeType === 8;
  }).each(function(i, e) {
    $(e.parentElement).append(e.nodeValue);
    $(e).remove();
  });
};

